// src/api.js

import axios from 'axios';

const isLocalhost = window.location.hostname === 'localhost';

const BASE_URL = isLocalhost
  ? 'http://localhost:7000/api'
  : 'https://apiviztech.in:7000/api'; // change to real prod URL

const api = axios.create({
  baseURL: BASE_URL,
});

export default api;
